export default __webpack_public_path__ + "static/media/Group 105.db29e687.svg";